const baseUrl = "https://moviesteamd.herokuapp.com/api/v1/review";

export const getReview = async () => {
    try {
        const response = await fetch(`${baseUrl}`, {
            method: 'GET',
        });
        return response.json();
    } catch (error) {
        console.log(error);
        throw error;
    };
};